// @flow

import * as React from 'react';
import { connect } from 'react-redux';
import styled from '@emotion/styled';
import pathToImage from 'app/images/app/powered-by-onesport.png';
import pathToImage2x from 'app/images/app/powered-by-onesport@2x.png';

type Props = {
  onesport: boolean
};

const StyledImage = styled.img({
  display: 'block',
  height: 16,
  marginTop: 10,
  width: 132
});

function PoweredBy({ onesport }: Props) {
  if (!onesport) {
    return null;
  }
  return (
    <StyledImage
      alt="Powered by OneSport"
      src={pathToImage}
      srcSet={`${pathToImage} 1x, ${pathToImage2x} 2x`}
    />
  );
}

function mapStateToProps(state) {
  return {
    onesport: state.settings.onesport
  };
}
export default connect(mapStateToProps)(PoweredBy);
